import { useQuery } from '@tanstack/react-query';
import { apiGet } from '@/lib/api';
import { clearAuthToken } from '@/lib/auth-token';
import type { AuthUser } from '@/types/auth';

export const authKeys = {
  me: ['auth', 'me'] as const,
};

export const fetchAuthUser = async (): Promise<AuthUser | null> => {
  try {
    return await apiGet<AuthUser>('/auth/me');
  } catch {
    clearAuthToken();
    return null;
  }
};

export const useAuthQuery = () =>
  useQuery({
    queryKey: authKeys.me,
    queryFn: fetchAuthUser,
    staleTime: 5 * 60_000,
    retry: false,
  });
